import type Author from "@gik/blog/models/Author";
import { useBemCN } from "@gik/core/utils/bemBlock";
import { AuthorAvatar } from "@gik/ui-legacy/Avatar";
import React from "react";

export interface IAuthorInfoProps {
	author: Author;
}

const blockName = "author-info";

export function AuthorInfo({ author }: IAuthorInfoProps) {
	const bem = useBemCN(blockName);

	return (
		<article {...bem()}>
			<div {...bem("avatar-container")}>
				<AuthorAvatar imageUrl={author.imageUrl} />
			</div>
			<div {...bem("about")}>
				<p {...bem("about-title")}>About the Author</p>
				<h1 {...bem("author-name")}>{author.fullName}</h1>
				<p {...bem("author-role")}>{author.role}</p>
			</div>
		</article>
	);
}
